import { useStrings } from "../../../localization/localizationHelpers";
import { GameConceptLanguages } from "../../../models/gameConceptLanguages";

export type LanguageItem = {
  value: string;
  label: string;
};

export const useLanguagesList = (): Array<LanguageItem> => {
  const [
    english,
    spanish,
    french,
    german,
    italian,
    russian,
    japanese,
    korean,
    polish,
    chineseTraditional,
    chineseSimplified,
    portugueseBrazilian,
  ] = useStrings(
    "english",
    "spanish",
    "french",
    "german",
    "italian",
    "russian",
    "japanese",
    "korean",
    "polish",
    "chineseTraditional",
    "chineseSimplified",
    "portugueseBrazilian"
  );

  return [
    {
      value: GameConceptLanguages.english,
      label: english,
    },
    {
      value: GameConceptLanguages.spanish,
      label: spanish,
    },
    {
      value: GameConceptLanguages.french,
      label: french,
    },
    {
      value: GameConceptLanguages.german,
      label: german,
    },
    {
      value: GameConceptLanguages.italian,
      label: italian,
    },
    {
      value: GameConceptLanguages.russian,
      label: russian,
    },
    {
      value: GameConceptLanguages.japanese,
      label: japanese,
    },
    {
      value: GameConceptLanguages.korean,
      label: korean,
    },
    {
      value: GameConceptLanguages.polish,
      label: polish,
    },
    {
      value: GameConceptLanguages.chineseTraditional,
      label: chineseTraditional,
    },
    {
      value: GameConceptLanguages.chineseSimplified,
      label: chineseSimplified,
    },
    {
      value: GameConceptLanguages.portugueseBrazilian,
      label: portugueseBrazilian,
    },
  ];
};
